import { combineReducers } from "redux";
import home from "./home"

export const reducers = combineReducers({
    home
})